import styled from '@emotion/styled';

const Content = styled.div`
  width: 100%;
  height: 100%;
  flex-grow: 1;
  text-align: center;
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
`;

export default Content;